import { useQuery } from '@tanstack/react-query';
import { IAICampaignRecipient } from '../../models/AICampaign';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'aiCampaign/recipients';

export function useAICampaignRecipients({
	bulkEmailMessageId,
	enabled = true,
}: {
	bulkEmailMessageId: string;
	enabled?: boolean;
}) {
	const userSession = useUserSession();
	return useQuery({
		enabled: enabled && !!bulkEmailMessageId,
		queryFn: async () => {
			return userSession.webServiceHelper.callAsync<IAICampaignRecipient[]>(
				`AICampaign/${encodeURIComponent(bulkEmailMessageId)}/recipients`,
				'GET'
			);
		},
		queryKey: [BASE_QUERY_KEY, bulkEmailMessageId],
		meta: {
			toastErrorMessage: 'Failed to load this campaign’s recipients',
		},
	});
}

export const invalidateAICampaignRecipients = (bulkEmailMessageId: string) => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY, bulkEmailMessageId] });
};
